import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=40369471"
import script from "./TopBanner.vue?vue&type=script&lang=js"
export * from "./TopBanner.vue?vue&type=script&lang=js"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=40369471&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmButton: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmButton.vue').default})
